/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { Table } from '@mantine/core'
import NoData from '../../../../client/js/components/NoData'
import SelectionToggle from '../../../../client/js/components/selection/SelectionToggle'
import TransactionListItem from './TransactionListItem'

export type TransactionListProps = {
  items: Transaction[]
  itemLink: string
}

function TransactionList (props: TransactionListProps) {
  const { items, itemLink } = props
  return (
    <Table highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th w={50}>
            <SelectionToggle />
          </Table.Th>
          <Table.Th w={120}>
            <FormattedMessage
              id="status"
              defaultMessage="État"
            />
          </Table.Th>
          <Table.Th w={120}>
            <FormattedMessage
              id="due_date"
              defaultMessage="Échéance"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="label"
              defaultMessage="Libellé"
            />
          </Table.Th>
          <Table.Th w={120} ta="end">
            <FormattedMessage
              id="amount_including_tax"
              defaultMessage="Montant TTC"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="customer"
              defaultMessage="Client"
            />
          </Table.Th>
          <Table.Th w={130}>
            <FormattedMessage
              id="invoice"
              defaultMessage="Facture"
            />
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {items.length > 0
          ? items.map((item) => (
            <TransactionListItem
              item={item}
              itemLink={itemLink}
              key={item.id}
            />
          ))
          : <Table.Tr>
            <Table.Td colSpan={7}>
              <NoData />
            </Table.Td>
          </Table.Tr>
        }
      </Table.Tbody>
    </Table>
  )
}

export default TransactionList
